import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../../i18n/it";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { UserFigureService } from "../../../../../auth/service/user-figure.service";
import { RequestService } from "../../request.service";
import { AuthenticationService, UserService } from "../../../../../auth/service";
import { ActivatedRoute, Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICustomer } from "../../../../customer/customer.interface";
import { CustomerService } from "../../../../customer/customer.service";

@Component({
  selector: "app-requests-list",
  templateUrl: "./requests-list.component.html",
  styleUrls: ["./requests-list.component.scss"]
})
export class RequestsListComponent implements OnInit {
  public contentHeader: IContentHeader;
  public tableLimit: number = 10;
  public filter_string: string = "";
  public filter_figure: number = 0;
  public filter_client: number = 0;
  public requests_list: any = [];
  public filtered_list: any = [];
  public filter_opened: number = 0;
  public customers: ICustomer[] = [];

  commercialList: { hash: string; complete_name: string; }[] = [];
  filterCommercial: { hash: string; complete_name: string; } = { hash: null, complete_name: null };
  filterFromDate: string = "";
  filterToDate: string = "";

  constructor(
    public _utilService: UtilsService,
    public _userFigureService: UserFigureService,
    public customerService: CustomerService,
    public requestService: RequestService,
    public _authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _userService: UserService
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.CUSTOMERS_REQUESTS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: italian.data.MENU.RECRUITMENT,
            isLink: false
          },
          {
            name: italian.data.MENU.CUSTOMERS_REQUESTS,
            isLink: false
          }
        ]
      }
    };

    this.activatedRoute.queryParams.subscribe((params) => {
      const searchKey = params.search;
      const figure = params.figure;
      const status = params.status;
      const client = params.client;
      if (!!searchKey && searchKey != 0) {
        this.filter_string = searchKey;
      }
      if (!!figure && Number(figure) > 0) {
        this.filter_figure = Number(figure);
      }
      if (!!status && Number(status) >= 0) {
        this.filter_opened = Number(status);
      }

      if (!!client && Number(client) > 0) {
        this.filter_client = Number(client);
      }
    });

    this._userService.getCommercialList().then((commercials) => {
      this.commercialList = commercials;
    });
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("view_customers_requests_list")) {
      this._utilService.hideLoading();
      this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.requests_list = await this.requestService.getRequestList();
    this.customers = await this.customerService.getCustomers();
    this.getItems();
    this._utilService.hideLoading();
  }

  getItems() {
    this.filtered_list = this.requests_list;

    const keyword: string = this.filter_string.toLowerCase();
    if (keyword.length >= 1) {
      this.filtered_list = this.filtered_list.filter((item: any) => item.request_name.toLowerCase().includes(keyword) || item.city?.toLowerCase().includes(keyword));
    }

    if (this.filter_figure > 0) {
      this.filtered_list = this.filtered_list.filter((item: any) => Number(item.figure_id) === Number(this.filter_figure));
    }

    if (this.filter_client > 0) {
      this.filtered_list = this.filtered_list.filter((item: any) => Number(item.client_id) === Number(this.filter_client));
    }

    if (this.filter_opened > -1) {
      this.filtered_list = this.filtered_list.filter((item: any) => item.closed === Boolean(this.filter_opened));
    }

    if (this.filterCommercial.hash) {
      this.filtered_list = this.filtered_list.filter((item: any) => item.commercial?.hash === this.filterCommercial.hash);
    }

    if (this.filterFromDate) {
      this.filtered_list = this.filtered_list.filter((item: any) => item.date >= this.filterFromDate);
    }

    if (this.filterToDate) {
      this.filtered_list = this.filtered_list.filter((item: any) => item.date <= this.filterToDate);
    }

    this.filtered_list = this.filtered_list.sort((a, b) => (a.id > b.id ? -1 : 0)).sort((a, b) => (a.priority > b.priority ? -1 : 0));

    this.changeQueryParams();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  clearFilterFrom() {
    this.filterFromDate = "";
    const picker: any = document.querySelector("#filterFromDate input");
    picker.value = "";
    this.getItems();
  }

  clearFilterTo() {
    this.filterToDate = "";
    const picker: any = document.querySelector("#filterToDate input");
    picker.value = "";
    this.getItems();
  }

  changeQueryParams() {
    const url = new URL(window.location.href);

    if (!!this.filter_string && this.filter_string.length >= 3) {
      url.searchParams.set("search", String(this.filter_string));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("search");
      history.pushState({}, "", url);
    }

    if (!!this.filter_figure && this.filter_figure > 0) {
      url.searchParams.set("figure", String(this.filter_figure));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("figure");
      history.pushState({}, "", url);
    }

    if (this.filter_opened > -1) {
      url.searchParams.set("status", String(this.filter_opened));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("status");
      history.pushState({}, "", url);
    }

    if (!!this.filter_client && Number(this.filter_client) > 0) {
      url.searchParams.set("client", String(this.filter_client));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("client");
      history.pushState({}, "", url);
    }
  }
}
